import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash2, MapPin } from "lucide-react";

export default function LocationsTab() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(true);
  const [adding, setAdding] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/locations");
      setItems(data);
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    setAdding(true);
    try {
      await api.post("/locations", { name: name.trim() });
      setName("");
      toast.success("Ubicación añadida");
      load();
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail));
    } finally {
      setAdding(false);
    }
  };

  const remove = async (id) => {
    if (!confirm("¿Eliminar?")) return;
    try {
      await api.delete(`/locations/${id}`);
      toast.success("Eliminada");
      load();
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail));
    }
  };

  return (
    <div className="space-y-4">
      <form onSubmit={add} className="flex gap-2">
        <input
          data-testid="location-name-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Nueva ubicación de recogida"
          className="flex-1 rounded-xl border border-neutral-300 bg-white px-4 h-11 text-sm focus:outline-none focus:ring-2 focus:ring-orange-500"
        />
        <button data-testid="location-add-button" disabled={adding} className="btn-primary">
          <Plus className="h-4 w-4" />
          Añadir
        </button>
      </form>
      {loading ? (
        <div className="card-surface p-8 text-center text-neutral-500">Cargando…</div>
      ) : items.length === 0 ? (
        <div className="card-surface p-10 text-center">
          <MapPin className="h-10 w-10 mx-auto text-neutral-300 mb-3" />
          <div className="text-sm text-neutral-500">
            Aún no hay ubicaciones. Añade la primera para empezar a crear citas.
          </div>
        </div>
      ) : (
        <div className="card-surface divide-y divide-neutral-100">
          {items.map((it) => (
            <div
              key={it.id}
              data-testid={`location-row-${it.id}`}
              className="flex items-center justify-between px-4 py-3"
            >
              <div className="font-medium">{it.name}</div>
              <button
                data-testid={`location-delete-${it.id}`}
                onClick={() => remove(it.id)}
                className="btn-ghost text-red-600 hover:bg-red-50"
              >
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
